import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 2rem;
  .content-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    h1 {
      font-size: 1.5rem;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.error};
    }
    svg {
      height: 2.5rem;
      fill: ${({ theme }) => theme.colors.error};
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  p {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.text};
    padding-top: 2rem;
  }

  textarea {
    border-radius: 0.5rem;
    border-color: ${({ theme }) => theme.colors.primary};
    padding: 0.5rem;
    font-size: 1rem;

    &:focus-visible {
      border-color: ${({ theme }) => theme.colors.secondary} !important;
    }
  }

  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 2rem;
    padding-top: 1.5rem;
    button {
      cursor: pointer;
      border: 0px;
      border-radius: 33px;
      transition: all 0.2s cubic-bezier(0.06, 0.67, 0.37, 0.99) 0s;
      text-transform: none;
      font-size: 21px;
      font-weight: 300;
      color: #fff;

      :nth-child(1) {
        overflow: hidden;
        outline: transparent;
        background-color: ${({ theme }) => theme.colors.primary};
        border: 1px solid ${({ theme }) => theme.colors.primary};
        font-size: 21px;
        font-weight: 300;
        :hover {
        }
      }

      :nth-child(2) {
        background-color: transparent;
        border: 1px solid ${({ theme }) => theme.colors.secondary};
        font-size: 21px;
        font-weight: 300;
        color: ${({ theme }) => theme.colors.secondary};
        :hover {
          color: ${({ theme }) => theme.colors.background_white};
          background-color: ${({ theme }) => theme.colors.secondary};
        }
      }
    }
  }
`;
